/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { environment } from "../environments/environment";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbCardModule,
  NbInputModule,
  NbSpinnerModule,
} from "@nebular/theme";

import {
  NbAuthJWTToken,
  NbAuthModule,
  NbPasswordAuthStrategy,
} from "@nebular/auth";
import { AuthGuard } from "./services/auth.service";
import { FormsModule } from "@angular/forms";

import { NbDateFnsDateModule } from "@nebular/date-fns";
import { HttpErrorInterceptor } from './@core/utils/http.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    NbCardModule,
    NbSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),

    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: "email",

          token: {
            class: NbAuthJWTToken,

            key: "data.jwt",
          },

          baseEndpoint: environment.BASE_API_URL,

          login: {
            endpoint: "/user/login",
            method: "post",
          },

          register: {
            endpoint: "/user/",
            method: "post",
          },
        }),
      ],
      forms: {
        login: {
          rememberMe: false,
          showMessages: {
            success: true,
          },
        },
      },
    }),

    NbToastrModule.forRoot(),

    FormsModule,
    NbDateFnsDateModule,
  ],

  providers: [AuthGuard, { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }],

  bootstrap: [AppComponent],
})
export class AppModule {}
